import request from '@/utils/request'

let Technical_trainingApi = {

  /*技术培训列表*/
  list(data) {
    return request._post('/shop/plus.technical_training.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.technical_training.Index/indexx', data);
},
/*添加技术培训*/
add(data) {
    return request._post('/shop/plus.technical_training.Index/add', data);
},
/*修改技术培训*/
edit(data) {
    return request._post('/shop/plus.technical_training.Index/edit', data);
},
/*删除技术培训*/
del(data) {
    return request._post('/shop/plus.technical_training.Index/del', data);
},
/*技术培训详情*/
detail(data) {
  return request._post('/shop/plus.technical_training.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.technical_training.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.technical_training.Setting/getSetting', data, errorback);
    },
}
export default Technical_trainingApi;



// WEBPACK FOOTER //
// ./src/api/technical_training.js